// extracted by mini-css-extract-plugin
module.exports = {"desktop-wrapper":"_3qASf","desktopWrapper":"_3qASf","mobile-wrapper":"_3eHec","mobileWrapper":"_3eHec"};